<template>
	<transition>
		<slot></slot>
	</transition>
</template>

<script>
export default {
	name: 'SlidedownAnimation'
}	
</script>

<style lang="stylus" scoped>
	.v-enter, .v-leave-to
		transform: translateY(100%);
	.v-enter-active, .v-leave-active
		transition: transform .3s
</style>
